import React, { Component } from 'react';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import CaseStudies from './CaseStudies/CaseStudies';
import Intro from './Intro/Intro';
import About from './About/About';
import { BrowserRouter } from 'react-router-dom';
import { ParallaxProvider } from 'react-scroll-parallax';
import './App.css';
// import Particles from './Particles/Particles';

class App extends Component {
  state = {
		width: window.innerWidth,
	};

	componentDidMount() {
		window.addEventListener('resize', this.handleWindowSizeChange);
    document.title = "ZackLerner.com"
	}

	// make sure to remove the listener
	// when the component is not mounted anymore
	// avoids memory leaks
	componentWillUnmount() {
		window.removeEventListener('resize', this.handleWindowSizeChange);
	}
	// dynamically detect window
	handleWindowSizeChange = () => {
		this.setState({
			...this.state,
			width: window.innerWidth,
		});
  };

	disableParallax(windowWidth) {
		return windowWidth <= 900 ? true : false;
	}

  render() {
    return (
			<BrowserRouter>
				<ParallaxProvider>
					<Header />
					<div className="App">
						<Intro isDisabled={this.disableParallax(this.state.width)} /> 
						<About isDisabled={this.disableParallax(this.state.width)} /> 
						<CaseStudies isDisabled={this.disableParallax(this.state.width)} />
						{/* <Particles /> */}
					<Footer />
					</div>
				</ParallaxProvider>
			</BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js